export default {
	props:{
	},
	data(){
		return {
			show:false,
			isFirstOpen:true,
		}
	},
	watch: {},
	computed: {},
	methods: {
		onShow(){
			if(this.show){ return; }

			if(this.isFirstOpen && (window.document.body.scrollTop || window.document.documentElement.scrollTop)===0){
				this.isFirstOpen = false;
				window.scrollTo(0, 1); //mobile browser hide address bar
			}

			let cwBefore = window.document.documentElement.clientWidth;
			window.document.documentElement.style.overflow = 'clip';
			window.document.body.style.overflow = 'clip';
			if(window.document.documentElement.clientWidth>cwBefore){
				window.document.body.style.paddingRight = (window.document.documentElement.clientWidth - cwBefore) + 'px';
			}
			window.addEventListener('keydown', this.onKeyDown, false);

			this.show = true;
		},
		onClose(){
			if(!this.show){ return; }

			setTimeout(()=>{
				window.document.documentElement.style.overflow = '';
				window.document.body.style.overflow = '';
				window.document.body.style.paddingRight = '';
			}, 500);

			window.removeEventListener("keydown", this.onKeyDown);

			this.show = false;
		},
		onKeyDown(ev){
			if(this.show && (ev.key==='Escape'||ev.key==='Esc'||ev.keyCode===27)){
				this.onClose();
			}
		},
		onToggle(){
			if(this.show){
				this.onClose();
			} else {
				this.onShow();
			}
		},
	},
	template: `
<div :class="['qit-sidebar-control', show?'show':'']">
	<slot name="activator" :on="{click:onToggle}">activator</slot>
	<div class="qit-sidebar-control-overlay" @click="onClose"></div>
	<div class="qit-sidebar-control-content">
		<span class="qit-sidebar-control-close-btn" @click="onClose"><span></span></span>
    <slot>content</slot>
	</div>
</div>
`,
}